import Axios from "./../../auth/axios";
import { loginApi, sendOtp, vendorOtpVerification, vendorTokenVerification, vendorPersonalInformation, vendorQualificationInformation, vendorBusinessInformation, vendorServiceInformation, getAllServices, getVendorInformation, getRegistrationOtp, vendorRegistrationForm, vendorRegistrationFormServices, generateNannyOtpApi, verifyNannyOtpApi, nannyStep1Api, nannyStep2Api, nannyStep3Api, nannyStep4Api} from './Index';

export const loginWithPassword = async (data) => {
  const result = await Axios.post(loginApi, data, {
    withCredentials: true
  });
  return result;
};

export const sendLoginOtp = async (data) => {
  const result = await Axios.post(sendOtp, data);
  return result;
};

export const verifyLoginOtp = async (data) => {
  const result = await Axios.post(vendorOtpVerification, data, {
    withCredentials: true
  });
  return result;
};

export const verifyVendorToken = async (data) => {
  const result = await Axios.post(vendorTokenVerification, data);
  return result;
};

export const savePersonalData = async (data) => {
  const result = await Axios.post(vendorPersonalInformation, data);
  return result;
};

export const saveQualificationData = async (data) => {
  const result = await Axios.post(vendorQualificationInformation, data);
  return result;
};

export const saveBusinessData = async (data) => {
  const result = await Axios.post(vendorBusinessInformation, data);
  return result;
};

export const saveServiceData = async (data) => {
  const result = await Axios.post(vendorServiceInformation, data);
  return result;
};

export const fetchAllService = async () => {
  const result = await Axios.get(getAllServices);
  return result;
};

export const fetchVendorInformation = async () => {
  const result = await Axios.get(getVendorInformation);
  return result;
};

export const fetchVendorAllServices = async () => {
  const result = await Axios.get(vendorRegistrationFormServices);
  return result;
};

export const sendRegistrationOtp = async (data) => {
  const result = await Axios.post(getRegistrationOtp, data);
  return result;
};

export const newVendorRegistration = async (data) => {
  const result = await Axios.post(vendorRegistrationForm, data);
  return result;
};

//nanny application form services

export const  nannyGenerateOtp= async (data) => {
  const result = await Axios.post(generateNannyOtpApi, data);
  return result;
};

export const  nannyVerifyOtp= async (data) => {
  const result = await Axios.post(verifyNannyOtpApi, data);
  return result;
};

export const  nannyStep1= async (data) => {
  const result = await Axios.post(nannyStep1Api, data);
  return result;
};

export const  nannyStep2= async (data) => {
  const result = await Axios.post(nannyStep2Api, data);
  return result;
};

export const  nannyStep3= async (data) => {
  const result = await Axios.post(nannyStep3Api, data);
  return result;
};

export const nannyStep4 = async (data) => {
  const result = await Axios.post(nannyStep4Api, data);
  return result;
};